<script setup lang="ts">
import ResultCard from "@/components/ResultCard/ResultCard.ce.vue";
import { useSearchStore } from "@/stores/search";
import { onBeforeMount, watch } from "vue";
import { storeToRefs } from "pinia";
import { t } from "@/services/i18n";
import { createSearchResultFunnelEvent } from "@/services/searchResultFunnelEventFactory";
import { VIEW_ITEM_LIST } from "@/globalConsts/searchFunnelEvents";
import { pushToDataLayer } from "@/lib/gtm/dataLayer";

const store = useSearchStore();
const { setResults } = store;
const { getResultItems, getTotalResults } = storeToRefs(store);

onBeforeMount(async () => {
    await setResults().then(() => {
        pushToDataLayer(
            createSearchResultFunnelEvent(
                VIEW_ITEM_LIST,
                getResultItems.value,
                -1
            )
        );
    });
});

const offsetHeight = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
        "--header-height"
    )
);

watch(getResultItems, () => {
    if (
        document.body.scrollTop > offsetHeight ||
        document.documentElement.scrollTop > offsetHeight
    ) {
        document.documentElement.style.scrollBehavior = "auto";
        document.body.scrollTop = offsetHeight; // For Safari
        document.documentElement.scrollTop = offsetHeight; // For Chrome, Firefox, IE and Opera
    }
});
</script>

<template>
    <div v-if="getTotalResults === 0" class="[ c-result-wrapper__text ]">
        <h3>{{ t("nothing_found") }}</h3>
        <p>{{ t("adjust_search") }}</p>
    </div>
    <div v-else class="[ c-result-container ]">
        <div
            v-for="(item, index) in getResultItems"
            :key="index"
            class="[ c-result-item ]"
        >
            <result-card :content="item" :index="index" />
        </div>
    </div>
</template>
